/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { PidxEscapeHtmlPipe } from './helpers/escape-html.pipe'
import { PidxNewLineTransformPipe } from './helpers/newline.pipe'
import { PidxClickTrackingDirective } from './pidx-tracking/pidx-click-tracking.directive'
import { PidxFormValidationTrackingDirective } from './pidx-tracking/pidx-form-validation-tracking.directive'

@NgModule({
  imports: [CommonModule],
  declarations: [PidxNewLineTransformPipe, PidxClickTrackingDirective, PidxFormValidationTrackingDirective, PidxEscapeHtmlPipe],
  exports: [PidxNewLineTransformPipe, PidxClickTrackingDirective, PidxFormValidationTrackingDirective, PidxEscapeHtmlPipe],
})
export class PidxUtilsModule {}
